<template>
  <div>
    <div class="item-head">
      <span class="badge badge-pill badge-warning text-capitalize">{{ item.type }}</span>
      <span class="badge badge-pill badge-light">{{ item.id }}</span>
      <input type="text" class="form-control title-input" v-model="item.title" placeholder="عنوان">
      <input type="text" class="form-control slug" placeholder="slug دسته" v-model="item.config['category_slug']">
      <b-icon class="bg-danger p-1 rounded-pill text-white" icon="trash" @click="deleteQuestion()"/>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChooseMultipleProductInput",
  props: {item: {}},
  methods: {
    deleteQuestion() {
      this.$emit('removeQuestion')
    }
  }
}
</script>

<style scoped>
.item-head { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; }
.item-head .form-control:not(.slug) { flex: 0 0 200px; }
.slug { flex: 0 1 140px !important; }
</style>
